import { Avatar, Box, IconButton, MenuItem, Popover, Select, Typography, useTheme, } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { observer } from 'mobx-react'
import { Icons } from '../../utils/utilities'
import { useUserStore } from '../../store/user.store'
import aliveLogo from '../../assets/alivelogo.png'
import { useThemeContext } from '../../contexts/theme.context'
import { Link } from 'react-router-dom'
import { useMeetingStore } from '../../store/meeting.store'
import { getTransformedMeetingType } from '../../utils/meeting-utilities'
import dayjs from 'dayjs'

const JoinMeetingHeader = observer( ( { } ) => {

    const [dateTime, setDateTime] = useState( dayjs().format( 'LLL' ) )
    const { palette } = useTheme()

    const UserStore = useUserStore()
    const MeetingStore = useMeetingStore()


    useEffect( () => {
        const interval = setInterval( () => {
            setDateTime( dayjs().format( 'LLL' ) )
        }, 10000 )
        return () => clearInterval( interval )
    }, [] )

    return (
        <Box bgcolor={palette.background.paper} alignItems="center" justifyContent=" space-between" height={`${50}px`} display="flex" maxWidth="100%" padding={{ md: "20px 40px", xs: "20px 10px" }} sx={{ transition: "0.2s ease-out" }}>
            <Link to={`${!UserStore.getUser.user_role ? "" : UserStore.getUser.user_role === "STUDENT" ? "" : "/faculty"}/meetings`} className='default-link' >
                <Box display="flex" gap="10px" alignItems="center">
                    <Box component="img" width="25px" src={aliveLogo} alt="Alive Logo" />
                    <Typography fontWeight={400} variant='h6' textTransform="capitalize" fontSize={{ sm: "16px", xs: "14px" }}>
                        {`Alive ${getTransformedMeetingType( MeetingStore.getCurrentMeeting.meeting_type, { forDisplay: true } )}`}</Typography>
                </Box>
            </Link>
            {<Box display="flex" alignItems="center" gap="10px">
                <Box display={{ sm: "block", xs: "none" }}>
                    <Typography marginBottom="-5px" textAlign="right" variant='subtitle2' textTransform="capitalize">{dateTime}</Typography>
                </Box>
                {( UserStore?.getUser["employee_name"] || UserStore?.getUser["student_name"] ) && <Avatar sx={{ fontSize: "14px", height: "25px", width: "25px", bgcolor: palette.primary.light, color: palette.primary.contrastText }}>
                    {( UserStore?.getUser["employee_name"] ? UserStore?.getUser["employee_name"] : UserStore?.getUser["student_name"] )?.substring( 0, 1 )}
                </Avatar>}
            </Box>}
        </Box>
    )
}
)
export default JoinMeetingHeader
